<script setup>
const markets = [
  {
    title: 'markets.items.0.title',
    region: 'markets.items.0.region',
    size: 'sm',
  },
  {
    title: 'markets.items.1.title',
    region: 'markets.items.1.region',
    size: 'md',
  },
  {
    title: 'markets.items.2.title',
    region: 'markets.items.2.region',
    size: 'xl',
    hasMore: true,
  },
];

const { tp } = useTypograf();
</script>

<template>
  <section class="section-markets">
    <div class="container">
      <div class="section-markets__inner">
        <div class="section-markets__head">
          <h2 class="section-markets__title">
            <span class="section-markets__font section-markets__font--title">
              {{ $t('markets.title') }}
            </span>
          </h2>

          <p class="section-markets__text">
            <span class="section-markets__font section-markets__font--text">
              {{ tp($t('markets.text')) }}
            </span>
          </p>
        </div>

        <div class="section-markets__cards">
          <CardMarket
            v-for="(market, index) in markets"
            :key="index"
            :title="$t(market.title)"
            :region="$t(market.region)"
            :size="market.size"
            :has-more="market.hasMore"
            class="section-markets__card"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.section-markets {
  &__inner {
    background: $color-gray-21 url('/images/section/markets/bg.png') no-repeat
      top center / cover;
    padding-block-start: em(60);
    padding-inline-end: em(67);
    padding-block-end: em(60);
    padding-inline-start: em(68);
    position: relative;

    @include media-breakpoint-mobile {
      padding-block-start: em(51);
      padding-inline: em(25);
      padding-block-end: em(29);
      background-image: url('/images/section/markets/bg-mobile.png');
    }
  }

  &__head {
    @include media-breakpoint-desktop {
      position: absolute;
      top: em(108);
      inset-inline-start: em(68);
    }

    @include media-breakpoint-mobile {
      margin-bottom: em(43);
      text-align: center;
    }
  }

  &__title {
    margin-bottom: em(67);
    display: inline-block;
    max-width: em(1075);

    @include gradient-text(
      linear-gradient(270deg, $color-black 0%, $color-second-1 68.9%)
    );

    @include media-breakpoint-mobile {
      margin-bottom: em(43);
    }
  }

  &__font {
    &--title {
      font-weight: $font-weight-semi-bold;
      font-size: em(80);

      @include media-breakpoint-mobile {
        font-size: em(30);
      }
    }

    &--text {
      font-weight: $font-weight-light;
      font-size: em(25);

      @include media-breakpoint-mobile {
        font-size: em(16);
      }
    }
  }

  &__text {
    @include media-breakpoint-desktop {
      max-width: em(478);
    }
  }

  &__cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: end;
    gap: em(46);

    @include media-breakpoint-mobile {
      display: block;
    }
  }

  &__card {
    @include media-breakpoint-mobile {
      & + & {
        margin-top: em(13);
      }
    }
  }
}
</style>
